import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "LayoutList",
  "use": "LayoutList-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"LayoutList\">\n    <path d=\"M13.833 2.167v11.666H2.167V2.167h11.666zM14.75.5H1.25a.747.747 0 00-.75.75v13.5c0 .333.333.75.75.75h13.5c.333 0 .75-.417.75-.75V1.25c0-.417-.417-.75-.75-.75zM7.167 3.833h5V5.5h-5V3.833zm0 3.334h5v1.666h-5V7.167zm0 3.333h5v1.667h-5V10.5zM3.833 3.833H5.5V5.5H3.833V3.833zm0 3.334H5.5v1.666H3.833V7.167zm0 3.333H5.5v1.667H3.833V10.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol